var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',{staticClass:"block-sign",class:{ 'block-sign--fixed': !_vm.isMobile }},[_c('a',{staticClass:"sign__link",attrs:{"href":_vm.website,"target":"_blank"}},[_c('img',{staticClass:"sign__logo",attrs:{"src":_vm.logo,"alt":""}}),_c('span',{staticClass:"sign__name"},[_vm._v(_vm._s(_vm.name))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }